/**
 * Frac's leadership and team roster — source of truth for /company.
 *
 * Rules enforced by this file (do not "clean up"):
 *   - Japhet's title is stored in full — never abbreviate the CEO / CTO
 *     slash-form in prose either. Render every role on its own line.
 *   - Wayne Yia + Alex Tan are NOT present (LinkedIn/URL not verified).
 *   - Qing Niao (formerly CTO) has been permanently removed per client.
 *   - `headshot: null` means render an initials-monogram fallback.
 */

// LEADERSHIP roster maintained per client instructions:
//   - Charmaine Wong (formerly CMO) removed 2026-02-17
//   - Taru Jain (formerly Chief Advisor) removed 2026-02-18 — not in
//     the supplied leadership photo folder
// Do not reinstate without explicit approval.
export const LEADERSHIP = [
  {
    name: "Japhet Lim",
    title:
      "Co-Founder & Chief Executive Officer / Chief Transformation Officer",
    li: "https://www.linkedin.com/in/japhet-lim/",
    headshot: "/team/japhet.png",
  },
  {
    name: "Melvin Tan",
    title: "Co-Founder & Chairman",
    li: "https://www.linkedin.com/in/melvintwy/",
    headshot: "/team/melvin.png",
  },
  {
    name: "Philip Tse",
    title: "Chief Financial Officer",
    li: "https://www.linkedin.com/in/philiptsefinancedirector/",
    headshot: "/team/philip.png",
  },
];

// TEAM roster maintained per client instructions:
//   - Yong Chin Bing (Business Development Lead) removed 2026-02-18
//   - Maiko Yamamoto (Technology & Operations Lead) removed 2026-02-18
//   - Eugene Ling (Design Director) removed 2026-02-18
//   - Ryan Lim (Growth Lead) removed 2026-02-18
//   - Nicholas Tan (Compliance Lead) removed 2026-02-18
//   - Jason F. (Director, Partnerships & Programs) removed 2026-08-18
// Reason: client instruction. Headshot file left in place under
// /public/team/ in case of reinstatement.
// Do not reinstate without explicit approval.
export const TEAM = [
  {
    name: "Jeanne Lim",
    title: "Public Relations Lead",
    li: "https://www.linkedin.com/in/jeanne-limkh/",
    headshot: "/team/jeanne.png",
  },
  {
    name: "Angela Tay",
    title: "Community Lead",
    li: "https://www.linkedin.com/in/angelatay1108/",
    headshot: "/team/angela.png",
  },
  {
    name: "Kennick Kek",
    title: "Innovation & Research Lead",
    li: "https://www.linkedin.com/in/kennick-kek-73ba92100/",
    headshot: "/team/kennick.png",
  },
  {
    name: "Jeffri Said",
    title: "Islamic Finance Lead",
    li: "https://www.linkedin.com/in/jeffri-said-406527159/",
    headshot: "/team/jeffri.png",
  },
  {
    name: "Paul Leong",
    title: "Head of Corporate Development",
    li: "https://www.linkedin.com/in/paul-jh-leong-8212b33a",
    headshot: "/team/paul.png",
  },
];

// REMOVED PERMANENTLY — do not reinstate:
//   Qing Niao (formerly listed as CTO) — confirmed removed by client
// DO NOT RENDER until confirmed:
//   Wayne Yia (Special Projects) — LinkedIn resolves to wrong profile
//   Alex Tan (Luxury Assets) — no LinkedIn URL on file

export const ENTITIES = [
  {
    name: "Frac Pte. Ltd.",
    location: "Singapore. IP holding, primary contracting entity.",
  },
  {
    name: "Frac Sdn. Bhd.",
    location: "Malaysia. Operations, engineering, growth.",
  },
  {
    name: "Diamond Alpha Technologies Pte. Ltd.",
    location: "Supply-chain tokenization technology, incubated inside Frac.",
  },
];

export const RECOGNITION = [
  {
    name: "Malaysia Digital (MD) Status",
    note: "Awarded by MDEC, the Malaysia Digital Economy Corporation",
  },
  { name: "MasChain Inaugural Developer Grant", note: "Sole winner" },
  { name: "VeChain", note: "Official partner" },
  { name: "Crypto.com APAC Hackathon", note: "Top 12" },
  { name: "Octopus Network Accelerator", note: "Star Prize" },
  { name: "Hedera Web3 Accelerator", note: "Top 20" },
  { name: "ByBit Blockchain for Good Alliance", note: "Incubated" },
  { name: "Tenity \u00D7 XDC Network Accelerator", note: "Accepted" },
  { name: "OHTC Western China", note: "4th Best Award" },
];

// Superseded by PARTNERS_CURATED in data/partners.js — keep until client
// confirms the new logo-grid on /company review.
export const PARTNERS = [
  { name: "XDC Network", href: "https://xdc.org" },
  { name: "Traxx Payments", href: null },
  { name: "Masverse", href: "https://masverse.com" },
  { name: "MasChain", href: "https://maschain.com" },
  { name: "Crypto.com", href: "https://crypto.com" },
  { name: "Quaich Bar", href: "https://quaichbar.com.sg" },
  { name: "Regal Rare", href: "https://regalrare.com" },
  { name: "Academic Labs", href: null },
  { name: "The Peak", href: "https://thepeak.io" },
  { name: "SBF (Singapore Business Federation)", href: "https://sbf.org.sg" },
  { name: "Sharky", href: null },
  { name: "GamBit Custody", href: null },
  { name: "StraitsX", href: null },
  { name: "Diamond Alpha", href: null },
  { name: "iGold", href: null },
  { name: "Planet Spirits", href: null },
  { name: "Hinterland", href: null },
  { name: "CAI Partners", href: null },
  { name: "VeChain", href: "https://vechain.org" },
  { name: "Hedera", href: "https://hedera.com" },
  { name: "Octopus Network", href: "https://oct.network" },
  { name: "Helium", href: "https://helium.com" },
];
